import React, { useEffect, useRef, useState } from 'react';
import { Grid, Label, Select, TextInput, Option, TextArea, Button, Variants, ButtonLink, TextTypes } from '@sede-enterprise/shell-ds-react-framework';
import { Col } from '../flexbox/Flex';
import { AnchorSpan } from '../styledComponent/StyledComponent';
import MinusCircle from '@sede-enterprise/shell-ds-react-framework/build/esm/components/Icon/components/MinusCircle';

import './styles.css'
import { AddCircle } from '@sede-enterprise/shell-ds-react-framework/build/esm/components/Icon/components';
import { formatDateToDDMMMYYYY } from '../../services/UtilService';
import { getData } from '../../services/ApiService';
import { ApiUrls } from '../../helpers/ApiUrls';
import { useParams } from 'react-router-dom';
import ResponseErrorModal from '../responseErrorModal/ResponseErrorModal';
import { APIErrorResponseInterface } from '../../helpers/InterfacesConstants';

interface formData{

    suppliedCustomerName?: string,
    suppliedCustomerCode?: string,
    suppliedAircraftRegistration?: string,
    suppliedCardNumber?: string,
    suppliedConco?: string,
    suppliedCreditType?: string,
    suppliedCustomerAccountNumber?: string,
    suppliedDelco?: string,
    suppliedDutyInd?: string,
    suppliedExternalInd?: string,
    suppliedFinalDestination?: string,
    suppliedFlightId?: string,
    suppliedNextDestination?: string,
    suppliedPackType?: string,
    suppliedVATInd?: string,

    nextDestinationResults: {confirmedNextDestination: string, suppliedNextDestination: string}[],

    confirmedCustomerName? : string ,
    confirmedCustomerCode? : string,
    confirmedCreditType? : string,
    confirmedConco? : string,
    confirmedDelco? : string,
    confirmedCustomerAccountNumber?: string,
    confirmedCardNumber? : string,
    confirmedVATInd? : string,
    confirmedDutyInd? : string,
    confirmedExternalInd? : string,
    confirmedPackType? : string,
    confirmedAircraftRegistration? : string,
    confirmedFlightId? : string,
    confirmedNextDestination? : string,
    confirmedFinalDestination? : string,
    comments? : string,
    filename?:File | null
};

const TicketForm = (props: any) => {
    const hiddenFileInput = useRef<HTMLInputElement>(null);
    const [customerAccountNumbers, setCustomerAccountNumbers] = useState(props.customerAccountNumbers);
    const [cardNumbers, setCardNumbers] = useState(props.cardNumbers);
    const [isCustomerCodeSearch, setIsCustomerCodeSearch] = useState(false);    
    const transaction = useParams();
    const setTransactionData = (obj:any) =>{
        props.onChange(obj);
    }


    
    const [apiErrorResponse, setApiErrorResponse] = useState<APIErrorResponseInterface | null>();

    const addNextDestination = () =>{
        setTransactionData({...props.transactionData,  nextDestinationResults: [...props.transactionData.nextDestinationResults, {confirmedNextDestination: '', suppliedNextDestination: ''}]});
    }

    const setNextDestination = (e: any, index: number) => {
        const tempDestination = props.transactionData.nextDestinationResults;
        tempDestination[index].confirmedNextDestination = e.target.value;
        setTransactionData({...props.transactionData, nextDestinationResults: tempDestination})
    }

    const removeNextDestination = (index: number) =>{
        const tempDestination= props.transactionData.nextDestinationResults;
        tempDestination.splice(index, 1);
        setTransactionData({...props.transactionData, nextDestinationResults: tempDestination})
    }

    const attachmentClick = () =>{
        hiddenFileInput.current && hiddenFileInput.current.click();
    }

    const checkCreditAndCardNumber = (credit: string, cardNumber: string) => {
        if(credit && credit === 'CN' && cardNumber && cardNumber.substring(0,3) === '705'){
            if(!customerAccountNumbers.includes('CAR')){
                setCustomerAccountNumbers([...customerAccountNumbers, 'CAR'])
            }
        }else{
            const index = customerAccountNumbers.indexOf('CAR');
            if( index > -1){
                if(props.transactionData.confirmedCustomerAccountNumber == 'CAR'){
                    setTransactionData({...props.transactionData, confirmedCustomerAccountNumber: null});
                }
                customerAccountNumbers.splice(index, 1);
                setCustomerAccountNumbers([...customerAccountNumbers]);
            }
        }
    }

    useEffect(() => {
        // Define the function to execute after debouncing
        const debounceSearch = setTimeout(() => {
            if(isCustomerCodeSearch && props.transactionData.confirmedCustomerCode){
                const url = ApiUrls.customeraccountnumber+'/'+transaction.headerId+'/'+props.transactionData.confirmedCustomerCode
                getData(url).then((response)=>{
                    if(!response.data.name){
                        
                        setApiErrorResponse({
                            message: "Please try with correct Customer Code!",
                            traceId : ""
                        });
                    }
                    if(props.transactionData.confirmedCreditType == 'CN' && props.transactionData.confirmedCardNumber.substring(0,3) === '705'){
                        setCustomerAccountNumbers([...response.data.customerAccountNumbers, 'CAR']);
                    }else{
                        setCustomerAccountNumbers([...response.data.customerAccountNumbers]);
                    }
                    setTransactionData({...props.transactionData, confirmedCustomerName:  response.data.name? response.data.name : ''});
                    setCardNumbers([...response.data.customerCardDetail]);
                }).catch((error)=>{
                    setTransactionData({...props.transactionData, confirmedCustomerName: ''});
                    
                    setApiErrorResponse({
                        message : error.response.data.message,
                        traceId : error.response.data.traceId
                    });
                });
            }
        }, 1000); // Adjust the time interval (e.g., 300ms) as needed.
        // Cleanup the timeout on each search term change
        return () => clearTimeout(debounceSearch);
    },[props.transactionData.confirmedCustomerCode]);

    useEffect(() => {
        setCustomerAccountNumbers(props.customerAccountNumbers);
	},[props.customerAccountNumbers]);

    useEffect(() => {
        setCardNumbers(props.cardNumbers);
	},[props.cardNumbers]);

    useEffect(() => {
        checkCreditAndCardNumber(props.transactionData.confirmedCreditType, props.transactionData.confirmedCardNumber);
	},[props.transactionData.confirmedCreditType, props.transactionData.confirmedCardNumber]);
  
    return(
        <>
            <Grid columns={2} gap='4%' >
                <div>
                    <Grid columns="30% 35% 35%" style={{width:"90%"}}>
                        
                        <Col size="100">&#32;</Col>
                        <Col size="100"><Label bold>Original Value</Label></Col>
                        <Col size="100"><Label bold>Edited Value</Label></Col>

                        <Col size="100"><Label bold type={TextTypes.Label} htmlFor='customerName'>Customer Name</Label></Col>
                        <Col size="100"><TextInput disabled={true} value={props.transactionData && props.transactionData.suppliedCustomerName} className='disabled' id='customerName'/></Col>
                        <Col size="100">
                            <TextInput disabled={true} value={props.transactionData && props.transactionData.confirmedCustomerName} className='disabled' id='customerName'/>
                        </Col>

                        <Col size="100"><Label bold type={TextTypes.Label} htmlFor='customerCode'>Customer Code</Label></Col>
                        <Col size="100"><TextInput disabled={true} value={props.transactionData && props.transactionData.suppliedCustomerCode} className='disabled' id='customerCode'/></Col>
                        <Col size="100"><TextInput value={props.transactionData && props.transactionData.confirmedCustomerCode} onChange={(e) => {setIsCustomerCodeSearch(true);setTransactionData({...props.transactionData, confirmedCustomerCode: e.target.value})}} id='customerCode'/></Col>

                        <Col size="100"><Label bold type={TextTypes.Label} htmlFor='creditType'>Credit Type</Label></Col>
                        <Col size="100"><TextInput disabled={true} value={props.transactionData && props.transactionData.suppliedCreditType} className='disabled' id='creditType'/></Col>
                        <Col size="100">
                            <Select onChange={(value) => {setTransactionData({...props.transactionData, confirmedCreditType: value})}} value={props.transactionData && props.transactionData.confirmedCreditType} id='creditType'>
                                {
                                    props.creditTypes && props.creditTypes.map((creditType:{code: string, desc: string}) => (
                                        <Option key={creditType.code} value={creditType.code}>{creditType.desc} ({creditType.code})</Option>
                                    ))
                                }
                            </Select>
                        </Col>

                        <Col size="100"><Label bold type={TextTypes.Label} htmlFor='conco'>Conco</Label></Col>
                        <Col size="100"><TextInput disabled={true} value={props.transactionData && props.transactionData.suppliedConco} className='disabled' id='conco'/></Col>
                        <Col size="100"><TextInput value={props.transactionData && props.transactionData.confirmedConco} onChange={(e) => setTransactionData({...props.transactionData, confirmedConco: e.target.value})} id='conco'/></Col>

                        <Col size="100"><Label bold type={TextTypes.Label} htmlFor='delco'>Delco</Label></Col>
                        <Col size="100"><TextInput disabled={true} value={props.transactionData && props.transactionData.suppliedDelco} className='disabled' id='delco'/></Col>
                        <Col size="100"><TextInput value={props.transactionData && props.transactionData.confirmedDelco} onChange={(e) => setTransactionData({...props.transactionData, confirmedDelco: e.target.value})} id='delco'/></Col>

                        <Col size="100"><Label bold type={TextTypes.Label} htmlFor='customerAccount'>Customer Account #</Label></Col>
                        <Col size="100"><TextInput disabled={true} value={props.transactionData && props.transactionData.suppliedCustomerAccountNumber} className='disabled' id='customerAccount'/></Col>
                        <Col size="100">
                            {props.transactionData.isLocalTicket ?     
                            <TextInput value={props.transactionData && props.transactionData.confirmedCustomerAccountNumber} 
                            onChange={(e) => {setTransactionData({...props.transactionData, confirmedCustomerAccountNumber: e.target.value});}} id='customerAccount' placeholder='Enter alpha numeric text'
                            onKeyDown={(e) => {
                                const regex = /^[a-zA-Z0-9]*$/;
                                if (!regex.test(e.key) && e.key !== 'Backspace' && e.key !== 'Enter') {
                                    alert("Special characters are not allowed.");
                                    e.preventDefault();                                                        
                                }
                                if (e.currentTarget.value.length >= 10 && e.key !== 'Backspace' && e.key !== 'Enter') {
                                    alert("Input must not exceed 10 characters.");
                                    e.preventDefault();
                                }
                            }}
                            />                              
                                :
                            <Select onChange={(value) => {setTransactionData({...props.transactionData, confirmedCustomerAccountNumber: value})}} value={props.transactionData.confirmedCustomerAccountNumber} id='customerAccount'>
                                {
                                    customerAccountNumbers && customerAccountNumbers.map((customerAccountNumber:string) => (
                                        <Option key={customerAccountNumber} value={customerAccountNumber}>{customerAccountNumber}</Option>
                                    ))
                                }
                            </Select>
                            }
                        </Col>

                        <Col size="100"><Label bold type={TextTypes.Label} htmlFor='cardNumber'>Card Number</Label></Col>
                        <Col size="100"><TextInput disabled={true} value={props.transactionData && props.transactionData.suppliedCardNumber} className='disabled' id='cardNumber'/></Col>
                        <Col size="100">
                            {props.transactionData.isLocalTicket ? 
                            <TextInput value={props.transactionData && props.transactionData.confirmedCardNumber} 
                            onChange={(e) => { setTransactionData({...props.transactionData,confirmedCardNumber: e.target.value});}} id='cardNumber' placeholder='Enter alpha numeric text'
                            onKeyDown={(e) => {
                                const regex = /^[a-zA-Z0-9]*$/;
                                if (!regex.test(e.key) && e.key !== 'Backspace' && e.key !== 'Enter') {
                                    alert("Special characters are not allowed.");
                                    e.preventDefault();                                                        
                                }
                                if (e.currentTarget.value.length >= 20 && e.key !== 'Backspace' && e.key !== 'Enter') {
                                    alert("Input must not exceed 20 characters.");
                                    e.preventDefault();
                                }
                            }}
                            />
                                :
                            <Select  onChange={(value) => {setTransactionData({...props.transactionData, confirmedCardNumber: value})}} value={props.transactionData.confirmedCardNumber} id='cardNumber'>
                                {
                                    cardNumbers && cardNumbers.map((cardNumber:string) => (
                                        <Option key={cardNumber} value={cardNumber}>{cardNumber}</Option>
                                    ))
                                }
                            </Select>
                            }
                        </Col>

                        <Col size="300"><hr></hr></Col>
                        <Col size="100"><hr></hr></Col>
                        <Col size="100"><hr></hr></Col>
                        

                        <Col size="100"><Label bold type={TextTypes.Label} htmlFor='vatInd'>Vat Ind</Label></Col>
                        <Col size="100"><TextInput disabled={true} value={props.transactionData && props.transactionData.suppliedVATInd} className='disabled' id='vatInd'/></Col>
                        <Col size="100">
                            <Select onChange={(value) => setTransactionData({...props.transactionData, confirmedVATInd: value})} value={props.transactionData && props.transactionData.confirmedVATInd} id='vatInd'>
                                <Option key="Yes" value="Yes">Yes</Option>
                                <Option key="No" value="No">No</Option>
                            </Select>
                        </Col>

                        <Col size="100"><Label bold type={TextTypes.Label} htmlFor='dutyInd'>Duty Ind</Label></Col>
                        <Col size="100"><TextInput disabled={true} value={props.transactionData && props.transactionData.suppliedDutyInd} className='disabled' id='dutyInd'/></Col>
                        <Col size="100">
                            <Select onChange={(value) => setTransactionData({...props.transactionData, confirmedDutyInd: value})} value={props.transactionData && props.transactionData.confirmedDutyInd} id='dutyInd'>
                                <Option key="Yes" value="Yes">Yes</Option>
                                <Option key="No" value="No">No</Option>
                            </Select>
                        </Col>

                        <Col size="100"><Label bold type={TextTypes.Label} htmlFor='externalInd'>External Ind</Label></Col>
                        <Col size="100"><TextInput disabled={true} value={props.transactionData && props.transactionData.suppliedExternalInd} className='disabled' id='externalInd'/></Col>
                        <Col size="100">
                            <Select onChange={(value) => setTransactionData({...props.transactionData, confirmedExternalInd: value})} value={props.transactionData && props.transactionData.confirmedExternalInd} id='externalInd'>
                                <Option key="Yes" value="Yes">Yes</Option>
                                <Option key="No" value="No">No</Option>
                            </Select>
                        </Col>
                        
                    </Grid>
                </div>


                <div>
                    <Grid columns="30% 35% 35%" style={{width:"90%"}}>
                        <Col size="100">&#32;</Col>
                        <Col size="100"><Label bold>Original Value</Label></Col>
                        <Col size="100"><Label bold>Edited Value</Label></Col>

                        <Col size="100"><Label bold type={TextTypes.Label}  htmlFor='aircraftRgistration'>Aircraft Registration</Label></Col>
                        <Col size="100"><TextInput disabled={true} value={props.transactionData && props.transactionData.suppliedAircraftRegistration} className='disabled' id='aircraftRgistration'/></Col>
                        <Col size="100"><TextInput value={props.transactionData && props.transactionData.confirmedAircraftRegistration} onChange={(e) => setTransactionData({...props.transactionData, confirmedAircraftRegistration: e.target.value})} id='aircraftRgistration'/></Col>

                        <Col size="100"><Label bold type={TextTypes.Label}  htmlFor='flightId'>Flight ID</Label></Col>
                        <Col size="100"><TextInput disabled={true} value={props.transactionData && props.transactionData.suppliedFlightId} className='disabled' id='flightId'/></Col>
                        <Col size="100"><TextInput value={props.transactionData && props.transactionData.confirmedFlightId} onChange={(e) => setTransactionData({...props.transactionData, confirmedFlightId: e.target.value})} id='flightId'/></Col>

                        {
                            props.transactionData.nextDestinationResults && props.transactionData.nextDestinationResults.map((nextDestination:{confirmedNextDestination: string, suppliedNextDestination: string}, index:number) => (
                                <>
                                <Col size="100"><Label bold type={TextTypes.Label} htmlFor='nextDestination'>Next Destination {index + 1}</Label></Col>
                                <Col size="100"><TextInput disabled={true} value={props.transactionData && props.transactionData.nextDestinationResults[index].suppliedNextDestination} className='disabled' id='nextDestination'/></Col>
                                <Col size="100">
                                    <div className={props.transactionData.nextDestinationResults.length  > 1  ? 'custom-shell-text-input':'fd'}>
                                        <TextInput style={{    width: '90%', display: 'inline-block'}} value={props.transactionData && props.transactionData.nextDestinationResults[index].confirmedNextDestination} onChange={(e) => setNextDestination(e, index)}/>
                                        {
                                            props.transactionData.nextDestinationResults.length > 1 && 
                                            <MinusCircle fill='#336094' height={25} width={25} onClick={() =>removeNextDestination(index)} style={{cursor:'pointer'}}/>
                                        }
                                    </div>
                                </Col>
                                </>
                            ))
                        }
                        

                        <Col size="100"><Label bold type={TextTypes.Label}  htmlFor='finalDestination'>Final Destination</Label></Col>
                        <Col size="100"><TextInput disabled={true} value={props.transactionData && props.transactionData.suppliedFinalDestination} className='disabled' id='finalDestination'/></Col>
                        <Col size="100">
                            <TextInput value={props.transactionData && props.transactionData.confirmedFinalDestination} onChange={(e) => setTransactionData({...props.transactionData, confirmedFinalDestination: e.target.value})}/>
                            {
                                props.transactionData && props.transactionData.nextDestinationResults && props.transactionData.nextDestinationResults.length < 4 &&
                                <ButtonLink className="add-next-destination" style={{float: 'inline-end', color:'#336094'}} onClick={()=>{addNextDestination()}}>Add Next Destination <AddCircle fill='#336094'  height={25} width={25} /></ButtonLink >
                            }
                            
                        </Col>
                    </Grid>


                    <Grid style={{width:"94%", marginTop:'20px'}} gap='0%'>
                        <Label bold type={TextTypes.Label}  htmlFor=''>Comments:</Label>
                        <Col size="100">
                        <TextArea maxLength={300} placeholder="Enter Comments" size="medium" rows={5} value={props.transactionData && props.transactionData.comments} onChange={(e) => setTransactionData({...props.transactionData, comments: e.target.value})}/>
                        <span className="light-text"> Maximum 300 characters are allowed</span>
                        </Col>
                        <div style={{marginTop:'20px'}}>

                            {props.selectedFiles && props.selectedFiles.length > 0 && (<div>
                                    <Label bold>Selected File:</Label>
                                    <ul>
                                        {props.selectedFiles.map((file: any, index:number) => (
                                        <li key={index}>{file.name}</li>
                                        ))}
                                    </ul>
                                    <button onClick={()=>{props.onFileCancel()}}>Remove</button>
                                </div>)
                            }
                            <AnchorSpan onClick={()=>{attachmentClick()}}><img src="/attachment.svg" alt="Attachment image" style={{top:'8px', position: 'relative'}}/>Attach File</AnchorSpan> 
                            <span className="light-text"> Maximum allowed file size is 5MB (.jpg, .pdf,. .xls)</span>
                            
                            <input
                                type="file"
                                ref={hiddenFileInput}
                                onChange={(e)=>{props.handleFileUpload(e)}}
                                style={{display:'none'}}
                            />

                        </div>
                        <div style={{marginTop:'20px', fontSize:'14px', color:'#343434'}}><Label bold>Last Edited By:</Label> {props.transactionData.editedBy} | <Label bold>Last Edited Date:</Label> {props.transactionData.modifiedDate && formatDateToDDMMMYYYY(props.transactionData.modifiedDate)}</div>
                        <div style={{textAlign:'right', marginTop:'40px'}}>
                            { props.onSaveAsDraft && <Button variant={Variants.Outlined} style={{marginLeft:'5px'}} onClick={()=>{props.saveAsDraft()}}>SAVE AS DRAFT</Button>}
                            
                            <Button variant={Variants.Outlined} style={{marginLeft:'5px'}} onClick={()=>{props.onCancel()}}>CANCEL</Button>
                            

                            { props.onSubmit && <Button style={{marginLeft:'5px'}} onClick={()=>{ props.onSubmit()}}>SUBMIT</Button>}
                        </div>
                    </Grid>
                    
                </div>
                            
            </Grid>

            <ResponseErrorModal errorDetails={apiErrorResponse} isOpen={apiErrorResponse? true : false} onModalClose={()=>{setApiErrorResponse(null)}}/>
        </>
    )
}
export default TicketForm;